import {Table} from '@tanstack/react-table';
import {DepartmentSelectInput} from '../../departments/components/department-select-input';
import {JobSelectInput} from '../../jobs/components/job-select-input';
import DataTableFilters, {
  DataTableFiltersProps,
} from '@/components/refinedev/data-table/data-table-filters';

type StaffFiltersProps = Pick<DataTableFiltersProps, 'table'>;

const StaffFilters: React.FC<StaffFiltersProps> = ({table}) => {
  return (
    <DataTableFilters table={table} className="w-[300px]">
      <div className="space-y-4">
        <div className="grid gap-2">
          <DepartmentSelectInput source="department_id" label="Phòng ban" />
          <JobSelectInput source="job_id" label="Công việc" />
        </div>
      </div>
    </DataTableFilters>
  );
};

export default StaffFilters;
